<template>
    <transition name="fade" v-if="error">
        <div class="invalid-feedback error-show-common d-block">
            {{ error }}
            <el-icon class="el-icon-warning"></el-icon>
        </div>
    </transition>
</template>

<script>
export default {
    props: ['error'],
    name: 'errorMessageAuth'
};
</script>
